<div style="width: 100%; height: 100%; margin: 0; padding: 0;">
 <!-- <button class="easymarine primary" style="border-radius: 10px; width: 191px; float: right;" (click)="openTicket()">Abrir Chamado</button> -->
  <!-- <iframe style="width: 100%;height: 1000px; border: 0" crossorigin="anonymous" [src]="path"></iframe> -->
  <!-- <iframe style="width: 100%;height: 1000px; border: 0" [src]="srcSite" crossorigin="anonymous"></iframe> -->
  <iframe  style="width: 100%; height: 1000px; border: 0; margin: 0; padding: 0;" crossorigin="anonymous" [src]="urlMarina"></iframe>
</div>
